'use strict'

import _groupBy from 'lodash/groupBy'

import template from './tracking.template.pug'

class TrackingController {
  constructor($mdDialog) {
    'ngInject'
    Object.assign(this, { $mdDialog })

    this.groupedByContainer = _groupBy(this.tracking, 'trackingNo')
    console.log(this.tracking)
    console.log(this.groupedTracking)
  }

  cancel() {
    this.$mdDialog.cancel()
  }
}

export const trackingComponent = {
  controller: TrackingController,
  controllerAs: '$ctrl',
  clickOutsideToClose: true,
  escapeToClose: true,
  template: template(),
  fullscreen: true,
  bindToController: true,
  multiple: true,
}

export const trackingConfig = ($mdDialogProvider) => {
  'ngInject'

  $mdDialogProvider.addPreset('trackingDialog', {
    options: () => {
      return trackingComponent
    },
  })
}



// WEBPACK FOOTER //
// ./app/orders/components/tracking/tracking.component.js